var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<select class=\"form-control\" ng-options=\"option.Key as (option.Name | i18next) for option in genders\" ng-model=\"value\" ng-disabled=\"ppdisable === 'true'\"> <option value=\"\" ng-i18next ng-if=\"emptyLabel\">{{ emptyLabel }}</option> </select>";
var id1="genderSelect.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/core/genderSelect.html
// module id = 63
// module chunks = 0 2